import styles from './OrderSummaryCardHeader.module.scss'

import React from 'react'

import ClassNames from 'classnames'
import Link from 'next/link'

import { parseDate, toLocaleDateString } from 'Utilities/DateUtilities/DateUtilities'
import { createClickedSegmentEvent } from 'Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import { GuaranteedBadge, PremiumBadge } from 'Organisms/OrderSummaryCard/IconBadge/IconBadge'

import Button from 'Molecules/Button'

import Divider from 'Atoms/Divider'
import Typography from 'Atoms/Typography'

const OrderBadges = ({ order }) => {
  const isPremium = ['Premium Delivery', 'One Day', 'Two Day'].includes(order.displayDeliveryLevel)

  return order.isGuaranteed || isPremium ? (
    <div className={styles.deliveryBadges}>
      {isPremium && <PremiumBadge />}
      {order.isGuaranteed && <GuaranteedBadge />}
    </div>
  ) : null
}

const OrderSummaryCardHeader = ({ order, onClickToOpenDetails, isCondensed }) => {
  return (
    <>
      <div className={styles.headerContainer}>
        <Typography
          size={isCondensed ? 1 : 1.25}
          font="bold"
          as="h2"
          className={styles.orderNumber}
          data-testid={`${order.orderNumber}_title`}
        >
          Order #
          {order.orderNumberSearchComponents
            ? order.orderNumberSearchComponents.map((c, i) => (
                <span
                  key={i}
                  className={ClassNames(styles.orderNumber, {
                    [styles.highlight]: c.isMatch,
                  })}
                >
                  {c.componentValue}
                </span>
              ))
            : order.orderNumber}
          <OrderBadges order={order} />
        </Typography>

        {!isCondensed && (
          <div className={styles.deliveredOrderInfoContainer}>
            <div>
              <Typography tone="subtle" size={0.875}>
                DATE ORDERED
              </Typography>
              <Typography>{toLocaleDateString(parseDate(order.orderDate), true)}</Typography>
            </div>
            {!order.cancellationDate && order.displayOrderTotal !== '$0.00' && (
              <div>
                <Typography tone="subtle" size={0.875}>
                  TOTAL
                </Typography>
                <Typography>{order.displayOrderTotal}</Typography>
              </div>
            )}
            {order.displayFutureOrderSubtotal && order.displayFutureOrderSubtotal !== '$0.00' && (
              <div>
                <Typography tone="subtle" size={0.875}>
                  FUTURE TOTAL
                </Typography>
                <Typography>{order.displayFutureOrderSubtotal}</Typography>
              </div>
            )}
            {order.cancellationDate && (
              <div>
                <Typography tone="subtle" size={0.875}>
                  TOTAL
                </Typography>
                <Typography>{order.displayCancelledTotal}</Typography>
              </div>
            )}
          </div>
        )}

        {!isCondensed && (
          <div className={styles.viewOrderButton}>
            <Link href={`/account/orderhistory/${order.publicOrderToken}`}>
              <Button
                text="View Order"
                size="small"
                segmentEvent={createClickedSegmentEvent('ViewOrder')}
                data-testid={`view_order_${order.orderNumber}`}
                brand="secondary"
                onClick={onClickToOpenDetails}
              />
            </Link>
          </div>
        )}
      </div>
      <Divider />
    </>
  )
}

export default OrderSummaryCardHeader
